import Select from "../Components/Select";

const Budget = ({ options, value, onChange }) => {
  return (
    <div className="budget-container">
      <span className="budget-container__title">
        Quel est votre budget mensuel ?
      </span>
      <Select
        placeholder="Sélectionnez un intervalle"
        options={options}
        value={value}
        onChange={(e) => onChange(e)}
      />
    </div>
  );
};

export default Budget;
